import InputField from "@metacrm/metacrm-material-ui/dist/InputField";
import { Box, IconButton } from "@mui/material";
import axios from "axios";
import LoadingComponent from "components/LoadingComponent/LoadingComponent";
import { apiUrl } from "features/configure";
import useCopyToClipboard from "hooks/useCopyToClipboard";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useOutletContext } from "react-router";

export default function WebhookImport() {
  const { formatMessage } = useIntl();
  const [link, setLink] = useState("");
  const [entityName] = useOutletContext();
  const dispatchSnackbar = useDispatchSnackbar();

  useEffect(() => {
    async function handleGetUrl() {
      try {
        const { data } = await axios(
          `${apiUrl}/api/userSource/${entityName}/webhook`
        );
        setLink(data?.importUrl);
      } catch (err) {
        dispatchSnackbar({ err });
      }
    }
    handleGetUrl();
  }, []);

  const copyFn = useCopyToClipboard(link);
  if (!link) return <LoadingComponent />;
  return (
    <>
      <Box mb="24px" color="#777" lineHeight="20px">
        {formatMessage({ id: "popup.cdpImport.webhook.description" })}
      </Box>
      <InputField
        title={formatMessage({ id: "popup.cdpImport.webhook.url" })}
        value={link}
        disabled
        endAdornment={
          <IconButton onClick={copyFn}>
            <i className="meta-crm-icon-ic_copy font-size-24" />
          </IconButton>
        }
        sx={{ color: "black" }}
      />
      <Box className="item-flex" mt="4px">
        <Box lineHeight="20px" color="#777">
          {formatMessage({ id: "popup.cdpImport.webhook.supportText" })}{" "}
        </Box>
        <Box
          lineHeight="20px"
          color="#7B61FF"
          sx={{ textDecoration: "underline", cursor: "pointer" }}
          ml="4px">
          {formatMessage({ id: "popup.cdpImport.learnMore" })}
        </Box>
      </Box>
    </>
  );
}
